var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100MusicBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4277 1.875H5.27148C5.08173 1.875 4.92773 2.029 4.92773 2.21875V7.29319C4.68161 7.12819 4.38633 7.03125 4.06836 7.03125C3.21552 7.03125 2.52148 7.72528 2.52148 8.57812C2.52148 9.43097 3.21552 10.125 4.06836 10.125C4.9212 10.125 5.61523 9.43097 5.61523 8.57812V4.625H10.084V6.60569C9.83786 6.44069 9.54258 6.34375 9.22461 6.34375C8.37177 6.34375 7.67773 7.03778 7.67773 7.89062C7.67773 8.74347 8.37177 9.4375 9.22461 9.4375C10.0775 9.4375 10.7715 8.74347 10.7715 7.89062V2.21875C10.7715 2.029 10.6175 1.875 10.4277 1.875Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100MusicBlue);
export default __webpack_public_path__ + "static/media/100-music-blue.d37482051fe6ec41dbf685bd17589947.svg";
export { ForwardRef as ReactComponent };